export default __webpack_public_path__ + "static/media/spark_41.be795f5f.png";